export const IN_PROGRESS = 'In-progress';
export const READY = 'Ready';
export const COMPLETE = 'Complete';
export const FAILED = 'Failed';
export const WAITING = 'Waiting';
export const AVAILABLE = 'Available';

declare global {
  interface Window {
    grecaptcha: any; 
  }
}

export type LinkInfo = {
  hostName: string
  linkId: string
  uId: string
  localeId: string
  destinationCountry: string
}

export type UrlParams = {
  designId: string
  configId: string
  productCode: string
  product: string
  language: string
  localeFullCode:string
  release: string
  productType: string
  cdProductType: string
}

export type UrlParamsContact = {
  contact: boolean
  productType: string
}

export type Doc = {
  name: string
  description?: string
  state: "Waiting" | "In-progress" | "Ready" | "Failed" | "Complete" | "Available"
  type?: string
  url?: string
  created?:string
  orderForm?:any
}

export type ApiCall = {
  type: string
  url: string
}

export type KeyValuePair = {[key: string]: any}

export type TermData = { key: string, value: string }

export type TranslationData = {
  countryCode: string
  languageCode: string
  translation: TermData[]
}

export type LanguageData = {
  code: string
  language: string
  lastPublished: number
}

export type LanguagesData = {
  all: LanguageData[]
  defaultLanguage: LanguageData[]
  primary: LanguageData[]
  rest: LanguageData[]
}
